// @flow

/**
 * @description Formats the user's language preferance for analytics
 * @param {String} locale The user's locale
 * @return {String} The formatted language string
 */
const formatLanguageString = (locale: string) => {
  switch (locale) {
    case 'en-US':
      return 'english language';
    case 'zh-CN':
      return 'mandarin language';
    default:
      return 'unknown language';
  }
};

export default formatLanguageString;
